<template>
    <div class="w-1200" style="padding-bottom: 60px;">
        <div class="font-24 font-500 mt-8">常见问题</div>
        <div class="mt-8" style="width: 1200px;height: 10px;background: #F7F9FA;"></div>
        <div class="item" v-for="item in questionList" :key="item.id">
            <div class="color-red font-32 font-600">{{item.title}}</div>
            <div class="mt-3" v-html="item.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'commonProblem',
        data() {
            return {
                questionList: []
            }
        },
        mounted() {
            this.getQuestion()
        },
        methods: {
            async getQuestion() {
                this.questionList = await this.$api.getQuestion()
            }
        },

    }
</script>
<style scoped lang="scss">
    .item {
        position: relative;
        padding: 40px 0;

        &::after {
            position: absolute;
            content: '';
            width: 1200px;
            height: 1px;
            background: #DDDDDD;
            left: 0;
            bottom: 0;
        }

        &:last-child::after {
            height: 0px;
        }

    }
</style>
